import { render, staticRenderFns } from "./ListaHistorialPaciente.vue?vue&type=template&id=44731d7c&scoped=true&lang=pug&"
import script from "./ListaHistorialPaciente.vue?vue&type=script&lang=js&"
export * from "./ListaHistorialPaciente.vue?vue&type=script&lang=js&"
import style0 from "./ListaHistorialPaciente.vue?vue&type=style&index=0&id=44731d7c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44731d7c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VContainer,VIcon,VRow})
